// extracted by mini-css-extract-plugin
module.exports = {"editbutton":"EditModeButton_editbutton__1Mxpf","inverted":"EditModeButton_inverted__16hnn"};